<template>
  <section
    id="admin-customer-list"
    :dir="$functions.currentLangDirection()"
  >
    <b-card class="admin-page-mobile">
      <b-button
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-primary'"
        @click="showModal"
      >
        <feather-icon
          icon="PlusIcon"
          size="22"
          class="align-text-top"
        />{{ $t('Add') }}
      </b-button>
      <v-data-table
        class="v-data-table"
        v-bind="{ dark : isMobile }"
        :headers="headers"
        :items="desserts"
        :search="search"
        mobile-breakpoint="0"
        loading
        :loading-text="$t('Loading')"
        :items-per-page="50"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('Search')"
            class="mx-4"
          />
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            style="margin-left:2px;"
            :title="$t('Edit')"
            @click="onEditItem(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            style="margin-right: 7px"
            :title="$t('Delete')"
            @click="onDeleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>

      <!-- modal login-->
      <b-modal
        id="modal-addCustomer"
        ref="modal-addCustomer"
        cancel-variant="outline-secondary"
        :ok-title="$t('Add')"
        :cancel-title="$t('Close')"
        centered
        :title="$t('New')"
      >
        <b-form>
          <b-form-group
            :label="$t('Mobile number')"
            label-for="v-mobile"
          >
            <b-form-input
              id="v-mobile"
              v-model="customer.mobile"
              class="numeric-input"
              maxlength="11"
              required
            />
          </b-form-group>
          <b-form-group
            :label="$t('Name')"
            label-for="v-name"
          >
            <b-form-input
              id="v-name"
              v-model="customer.name"
              required
            />
          </b-form-group>
          <b-form-group
            :label="$t('Family')"
            label-for="v-family"
          >
            <b-form-input
              id="v-family"
              v-model="customer.family"
              required
            />
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-addCustomer')"
          >
            {{ $t('Close') }}
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalAddCustomer()"
          >
            {{ $t('Save') }}
          </b-button>
        </template>
      </b-modal>
    </b-card>

  </section>

</template>
<script>
import {
  BCard, BCardBody, BButton, BFormGroup, BFormInput, BForm, BInputGroup,
} from 'bootstrap-vue'

// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Vue from 'vue'
import router from '@/router'
import customerService from '@/services/customer.service'
import Customer from '@/models/customer'

export default {
  components: {
    BFormGroup,
    BCard,
    BCardBody,
    BButton,
    BFormInput,
    BForm,
    BInputGroup,
  },
  data() {
    return {
      search: '',
      customer: new Customer('', '', '', '', '', ''),
      desserts: [],
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'نام',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'نام خانوادگی', value: 'family', sortable: true },
        { text: 'شماره موبایل', value: 'mobile', sortable: true },
        { text: 'تاریخ ایجاد', value: 'creationDate', sortable: true },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async created() {
    this.$vuetify.rtl = true
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
    },
  },
  methods: {
    initialize() {
      customerService.getAll({ _id: this.selected, type: 0 }).then(
        res => {
          if (res.status === 'success') {
            console.log(res.status)
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                const temp = res.result.data[i]
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                this.desserts.push(temp)
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ path: '/admin/user/add' })
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        customerService.delete({
          // eslint-disable-next-line no-underscore-dangle
          userId: this.desserts[index]._id,
          companyId: localStorage.getItem('companySelected'),
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'خطا',
                  text: res.message,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
    },
    onEditItem(item) {
      this.customer = {}

      const index = this.desserts.indexOf(item)

      // eslint-disable-next-line no-underscore-dangle
      const id = this.desserts[index]._id
      /*
      this.customer.name = this.desserts[index].name
      this.customer.family = this.desserts[index].family
      this.customer.mobile = this.desserts[index].mobile

      this.$refs['modal-addCustomer'].show()
*/
      router.push({ name: 'admin-customer-edit', params: { id } })
    },
    modalAddCustomer() {
      // eslint-disable-next-line no-underscore-dangle,radix
      customerService.addUser(this.customer).then(
        res => {
          if (res.status === 'success') {
            this.initialize()
            this.$bvModal.hide('modal-addCustomer')
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'خطا',
                text: res.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    showModal() {
      this.customer = {}
      this.$refs['modal-addCustomer'].show()
    },
  },
}
</script>
<style>
/* استایل هدر ثابت */
thead th {
  position: sticky;
  top: 0;
  background-color: #ebebeb; /* برای جلوگیری از تداخل رنگ با محتوای جدول */
  z-index: 100; /* برای اطمینان از اینکه هدر روی سایر محتواها قرار گیرد */
  border: 1px solid #bcbcbc;
}
[dir] thead th {
  background-color: #ebebeb;
  border: 1px solid #bcbcbc !important;
}

table {
  width: 100%;
  border-collapse: collapse;
  overflow-y: auto;
  display: block;
  max-height:400px; /* حداکثر ارتفاع برای ایجاد اسکرول */
}

th {
  width: 325px;
}
</style>
